import React, {useState,useEffect,useContext} from 'react'
import downArrow from "../images/orgarrow.svg";
import { useNavigate } from "react-router-dom";
import arrow from '../images/thinArrow.png'
import checkmarkGreen from '../images/checkmark-green.png';
import checkmarkRed from '../images/checkmark-red.png'
import calendar from '../images/Icon-Calendar.png';
import moment from 'moment';
import { DayPicker  } from 'react-day-picker';
import da from "date-fns/locale/da";
import close from '../images/close.png'
import { keyContext } from "../components/KeyContext";
import { format, isSameMonth } from "date-fns";
import NewsletterDiv from '../components/NewsletterDiv';
import NoteModal from '../components/Modals/NoteModal';

function NotSentNewsletter({leftMargin}) {

  const key = sessionStorage.getItem("key");
  const [bios, setBios] = useState([{}]);
  const navigate = useNavigate();
 
  const [chosenBio, setchosenBio] = useState(sessionStorage.getItem('newsletter_bio') ? sessionStorage.getItem('newsletter_bio') : '');
  const [orgID, setOrgID] = useState(); 
  const [newsletters, setNewsletters] = useState([]);
  const [newsletterModal, setNewsletterModal] = useState(false);
  const [newsletterDelete, setNewsletterDelete] = useState(false);
  const [deletedNewsletterNo, setDeletedNewsletterNo] = useState()
  const { deletedNewsletter,setClickedNewsletter,clickedNewsletter} = useContext(keyContext)
 
   let ge = sessionStorage.getItem('newsletter_bio')
   let news_orgs = ge?.split(" ")[ge.split(" ").length - 1]
  
    useEffect(() => {   
      if(sessionStorage.getItem('newsletter_bio')) {
       let ge = sessionStorage.getItem('newsletter_bio')
       setOrgID(ge.split(" ")[ge.split(" ").length - 1])
      }
   }, []);

   useEffect(() => {
      if(bios.length === 1) {
         setOrgID(bios[0].No)
      }
    }, [bios]);

    

  // get organizer fetch
   useEffect(() => {
      const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getorganizers?Key=${key}`;
      if (key) {
        fetch(endpoint, {
          method: "GET",
          headers: {
            ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
          },
        })
          .then((res) => {
            if (res.status !== 200) {
              navigate("/");
            }
            return res.json();
          })
          .then((result) => {
            // console.log(result)
            setBios(result);
  
            // console.log('biograf length',result.length)
            if (result.length === 1) {
            }
            // setMovieNumber(result.map((number) => number.No));
          });
      }
    }, [key]);

 
      // existing templates fetch
       useEffect(() => {
           if(key && (orgID || news_orgs)) { 
          
              const endpoint =`https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_get?Key=${key}&OrgNo=${news_orgs?news_orgs:orgID}`;
               fetch(endpoint, {
                  method: "GET",
                  headers: {
                    ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                  },
                
                })
                .then(res => {    
                 return res.json()
                })
                .then(result => {
                   setNewsletters(result)
                 
                })
             }
         }, [key,orgID,news_orgs]);

  
    function handleBioSelect (e) {
        setchosenBio(e.target.value);
        let g = e.target.value;
        setOrgID(g.split(" ")[g.split(" ").length - 1]);
         sessionStorage.setItem('newsletter_bio',e.target.value)
    }

 
  
   const svg = ` <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
               <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
            </svg>`


  function deleteNewsletter () {
        setNewsletterDelete(true)
        setNewsletterModal(false)
         const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_delete?Key=${key}&NewsletterNo=${clickedNewsletter}`
        fetch(endpoint, {
                   method: "GET",
                   headers: {
                     ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                   },
                 
                 })
                 .then(res => {    
                  return res.json()
                 })
                 .then(res => { 
   
                 setNewsletters(prevItems =>
                        prevItems.filter(item => item.No !== clickedNewsletter)
                   );
                })
      }
     

  function dontDeleteNewsletter () {
        setNewsletterDelete(false)
        setNewsletterModal(false)
        setClickedNewsletter()
  }



  return (
    <div id='tes' className='NotsentNewsletter'> 
      { newsletterModal === true ? 
         <div  className="modal-backdrop"  
       style={{top:'0px',width:'1440px',height:'100%',backgroundColor:'rgba(0,0,0,0.5)',left:leftMargin+'px'}} > 
         <div style={{backgroundColor:'white',height:'200px',width:'350px',textAlign:'center',alignContent:'center',borderRadius:'4px'}}> <h4>Vil du slette nyhedsbrev? </h4>
          <div style={{marginTop:'20px'}}> <button onClick={deleteNewsletter} style={{backgroundColor:'#982F2F',color:'white',width:'40px',borderRadius:'2px',marginRight:'5px'}}>ja</button> 
            <button onClick={dontDeleteNewsletter} style={{backgroundColor:'#982F2F',color:'white',width:'40px',borderRadius:'2px'}}>nej</button> </div>
           
         </div>
       </div> 
     :null}
      <p className='newsletter_title'>Ikke udsendte nyhedsbreve</p>
         <label htmlFor="" style={{fontSize:'18px',fontWeight:700,letterSpacing:'0.36px',color:'#46484c',marginBottom:'11px',marginTop:'30px'}}>Biograf</label>
         <div className="movieListBox" style={{width: "384px",}}> 
     
          <span className="select-line" style={{ backgroundColor: "#8d8d8d" ,position:'absolute',right:'30px',width:'0.5px'}}></span>
          {/* <span style={{position:'absolute',top:'8px',right:'12px'}}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
               <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
            </svg></span> */}
            
        <select  onChange={handleBioSelect} 
                  className="form-select text-truncate"
                  value={chosenBio}
                  style={{
                    height: "40px",
                    border: "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",
                    color:'#46484c',letterSpacing:'0.32px',   
                    // background:'transparent'            
                    backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(svg)}")`,
                  }}
                >
                 {bios &&
                    bios.map((item) => {
                      let bb = item.City + " - " + item.Name + " " + item.No;
                      return (
                        <option
                          key={item.id}
                          value={bb}
                          className="text-truncate"
                          style={{
                            maxWidth:'380px',
                            marginLeft: "10px",
                            fontSize: "16px",width:'370px'
                          }}
                        >
                          {item.City} - {item.Name}
                        </option>
                      );
                    })}
        </select>
       </div>
       {newsletters.length ?
        <div className='newsMailHeader'> 
          <p style={{alignContent:'center',margin:0,letterSpacing:'0.32px'}}>Navn på nyhedsmail</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center',letterSpacing:'0.32px'}}>Segment</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center',letterSpacing:'0.32px'}}>Udsendelsesdato</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center',letterSpacing:'0.32px'}}> Tidspunkt</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center',letterSpacing:'0.32px'}}>Udsendelse aktiveret</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center',letterSpacing:'0.32px',width:'50px'}}></p>
        </div>
        : '' }
       
       { !newsletters.length && chosenBio ? <p style={{marginTop:'20px'}}>ingen ikke udsendte nyhedsbreve</p> : null}
       
       {newsletters.map(newsletter => {
          if(moment(newsletter.Sendt).format('YYYY') === '1900')
          return  <NewsletterDiv key={newsletter.No} leftMargin={leftMargin} newsletter_data={newsletter} orgID={news_orgs?news_orgs:orgID}  newsletterModal={newsletterModal} setNewsletterModal={setNewsletterModal} newsletterDelete={newsletterDelete} setNewsletterDelete={setNewsletterDelete} setDeletedNewsletterNo={setDeletedNewsletterNo}/>
        
        }
        )}
           

        </div>
   
  )
}

export default NotSentNewsletter